import "./App.css";

import { Footer } from "./screen";
import { StarGame } from "./components/StarGame";

function App() {
  return (
    <>
      <StarGame />
      <Footer />
    </>
  );
}
export default App;
